import DrupalImage from '@commons/components/Image/Drupal';
import RichText from '@commons/components/RichText';
import Flex from '@commons/containers/Flex';
import { breakpoints } from '@commons/contexts/responsive';
import type { DrupalImage as DrupalImageType, DrupalParagraph } from '@commons/types/drupal';
import type { Width } from '@commons/types/styles';

/**
 * Next.js Image `sizes` property for responsive images.
 *
 * @see https://nextjs.org/docs/app/api-reference/components/image#sizes
 */

const IMAGE_SIZES = `(max-width: ${breakpoints.md}px) 100vw, (max-width: ${breakpoints.lg}) 464px, (max-width: ${breakpoints.xl}) 550px, 768px`;

// Type definition for the TextImage paragraph properties.

type Props = DrupalParagraph & {
  text: string;
  image: DrupalImageType;
  imageSide: 'left' | 'right';
  mobileReverse: boolean;
  imageWidth?: Width;
  textWidth?: Width;
};

/**
 * TextImage paragraph component.
 */

const TextImageParagraph = ({
  text,
  image,
  imageSide,
  mobileReverse,
  imageWidth = 5,
  textWidth = 4,
}: Props) => {
  const renderedContent = [
    <RichText value={text} width={{ xs: 12, md: 6, lg: textWidth }} key="text" />,
    <Flex.Item width={{ xs: 12, md: 6, lg: imageWidth }} key="image">
      <DrupalImage {...image} sizes={IMAGE_SIZES} />
    </Flex.Item>,
  ];

  if (imageSide === 'left') renderedContent.reverse();

  const mobileDirection = mobileReverse ? 'column-reverse' : 'column';

  return (
    <Flex
      gap="xl"
      width={12}
      justify="space-between"
      direction={{ xs: mobileDirection, md: 'row' }}
    >
      {renderedContent}
    </Flex>
  );
};

export default TextImageParagraph;
